/**
 * CancelReasonScreen — adaptateur primaire de la route `cancel-reason` (étape 1/5).
 *
 * Fil : l'état local du motif → la page du DS. Aucun service, aucun store.
 */
import React from "react"

import { CancelReasonPage } from "../../../../../../design-system"
import { type CancelFlowScreenProps } from "./cancelFlowNavigation"
import { useCancelReasonState } from "./useCancelReasonState"

export function CancelReasonScreen(props: CancelFlowScreenProps) {
    const routeParams = props.route?.params ?? {}
    const { reasons, selectedReason, detail, actions } = useCancelReasonState({ routeParams })

    return (
        <CancelReasonPage
            reasons={reasons}
            selectedReason={selectedReason}
            onSelectReason={actions.onSelectReason}
            detail={detail}
            onDetailChange={actions.onDetailChange}
            onContinue={actions.onContinue}
            onBack={actions.onBack}
            onClose={actions.onClose}
        />
    )
}

export default CancelReasonScreen
